import { mount } from 'svelte';
import App from './App.svelte';

const propsEl = document.getElementById('app-props');
const props = propsEl ? JSON.parse(propsEl.textContent) : undefined;

const app = mount(App, {
	target: document.getElementById('app'),
	props,
});

export default app;
